import { visibleButton } from "./include/module";
import { anchorLink } from "./include/module";

(() => {
  visibleButton();
  anchorLink();
})();



// WEBPACK FOOTER //
// script.js